<template>
  <Component
    :is="event.artist ? BaseLink : 'div'"
    class="card"
    :link="
      event.artist
        ? { anchor_type: 'artist', slug: event.artist.slug }
        : undefined
    "
    :class="`card--${color}`"
  >
    <div v-if="event.artist" class="image-container">
      <BaseImage
        :image="event.artist.image"
        sizes="12vw"
        :img-sizes="[{ w: 176, h: 176 }]"
      />
    </div>
    <div class="content">
      <div class="top">
        <p class="time">
          {{ formatDate(event.date, 'HH:mm') }}
        </p>
        <Arrows v-if="event.artist" class="arrows" />
      </div>
      <div class="details">
        <h2>
          <span class="event-name">{{ event.name }}</span>
          <span
            v-if="event.artist?.country && event.artist.title === event.name"
            class="country t-caption-small"
          >
            {{ event.artist.country }}
          </span>
        </h2>
        <EventDescription
          size="small"
          :date="event.fixed_date"
          :place="place"
          :timezoned="false"
        />
      </div>
    </div>
  </Component>
</template>

<script lang="ts" setup>
import { LineUpEvent, PlaceColorEnum } from '@/service/__generated-api'

defineProps<{
  event: LineUpEvent
  place: string
  color: PlaceColorEnum
}>()

const BaseLink = resolveComponent('BaseLink')
</script>

<style lang="scss" scoped>
.card {
  @include focus-visible;
  display: flex;
  height: rem(176px);
  overflow: hidden;

  &:hover {
    .image-container {
      margin-left: 0;
    }

    .arrows :deep(path) {
      animation-name: move;
    }
  }

  @each $key, $value in $places-colors {
    &--#{'' + $key} {
      background-color: $value;

      .arrows {
        color: $value;
      }
    }
  }
}

.image-container {
  flex-shrink: 0;
  width: rem(138px);
  height: 100%;
  margin-left: rem(-138px);
  transition: margin-left $transition;
}

.content {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.top {
  display: flex;
  justify-content: space-between;
}

.time {
  padding-top: rem(24px);
  padding-left: rem(24px);

  /* Desktop/Text/caption */
  font-size: rem(15px);
  font-weight: 700;
  line-height: rem(16px);
}

.arrows {
  @include size(rem(40px));
}

.details {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: rem(16px);
  justify-content: flex-end;
  padding: rem(24px);
  padding-top: 0;
}

.event-name {
  font-size: rem(26px);
  font-weight: 700;
  line-height: rem(28px);
  letter-spacing: -0.01em;
}

.country {
  position: relative;
  top: rem(2px);
  margin-left: rem(10px);
  vertical-align: top;
}
</style>
